/* global fetch */
'use strict';

function fireBeacon(beaconUrl, articleId) {
    let referrer = document.referrer || '';
    fetch(beaconUrl, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
        }),
        mode: 'no-cors',
        body: `a=${articleId}&rf=${encodeURIComponent(referrer)}`,
    });
}

module.exports = {
    fireBeacon: fireBeacon,
};
